function CategoryC() {
    return (
        <div>
            CategoryC
        </div>
    );
}

export default CategoryC;